import {Routes} from '@angular/router';
import {DASHBOARD_ROUTES} from '@pages/dashboard/dashboard.routes';
import {USERS_ROUTES} from '@pages/users/users.routes';
import {SUPPORT_ROUTES} from '@pages/support/support.routes';
import {FILEMANAGER_ROUTES} from '@pages/filemanager/filemanager.routes';
import {DEVICES_ROUTES} from '@pages/devices/devices.routes';
import {CONVERSATIONS_ROUTES} from '@pages/conversations/conversations.routes';

export const FULL_LAYOUT_ROUTES: Routes = [
  {path: '', children: DASHBOARD_ROUTES},
  {path: 'users', children: USERS_ROUTES},
  {path: 'support', children: SUPPORT_ROUTES,},
  {path: 'filemanager', children: FILEMANAGER_ROUTES,},
  {path: 'devices', children: DEVICES_ROUTES},
  {path: 'conversations', children: CONVERSATIONS_ROUTES}
];
